/* @flow */
import React from 'react';

const ReceiptRow = React.createClass({
  render() {
    const children = React.Children.map(this.props.children, function(child, index) {
      return (
        <td key={index}>
          {child}
        </td>
      );
    });

    return (
      <tr className={this.props.className}>
        {children}
      </tr>
    );
  },
});

export default ReceiptRow;



// WEBPACK FOOTER //
// ./src/payments/components/ReceiptRow.jsx